import { Box } from '@mui/material';
import { Suspense } from 'react';

import { Loading } from '../../components/progress';
import { DashboardService } from '../../services';
import FacilityChooserModal from './FacilityChooserModal';
import { ContentGrid, Toolbar } from './components';
import { DashboardProvider } from './contexts';
import { useFacilityContext } from './contexts/FacilityProvider';

function Dashboard() {
  const { state: facilityState } = useFacilityContext();
  const { selectedFacility } = facilityState;

  return (
    <>
      {selectedFacility && (
        <DashboardProvider key={selectedFacility} facility={selectedFacility}>
          <Box
            sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}
          >
            <Toolbar />
            <Suspense fallback={<Loading />}>
              <ContentGrid />
            </Suspense>
          </Box>
        </DashboardProvider>
      )}
      <FacilityChooserModal />
    </>
  );
}

export default Dashboard;

export type TdashboardLoader = {
  facilityList: any[];
  primaryFacility?: string;
};
export async function dashboardLoader(): Promise<TdashboardLoader> {
  let facilityList: any[] = [];
  let primaryFacility = undefined;
  try {
    const res = await DashboardService.getFacilities();
    if (res.status === 200) {
      facilityList = res?.data?.facilities || [];
      primaryFacility =
        Array.isArray(facilityList) && facilityList.length === 1
          ? facilityList[0]
          : res?.data?.primary_facility || undefined;
    }
  } catch (error) {
    console.error('API Error 💥', error);
    throw new Response('Not Found', { status: 404 });
    // throw error;
  }
  if (!Array.isArray(facilityList) || facilityList.length === 0)
    throw new Response('Not Found', { status: 404 });
  return {
    facilityList,
    primaryFacility:
      typeof primaryFacility === 'string' ? primaryFacility : undefined,
  };
}
